<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="count.selected && count.selected > 0">{{ count.selected }}</span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomToggle
                    :modelValue="toggleValues"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    :options="optionsArray"
                    :showLabel="false"
                    :showDescription="false"
                    ref="optionsExtra"
                    cssClass="custom-toggle-type-2"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import CustomToggle from '@/components/elements/inputs/CustomToggle';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';

    export default {
        name: "OptionsExtra",
        components: {
            ToggleSimple,
            CustomToggle
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({})
            },
            defaultVal: {
                type: Object,
                default: () => ({})
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'dataset_settings',
                toggleOpen: false,
                options: {
                    coc_required: 'fields.dataset_settings.options.coc_required',
                    address_required: 'fields.dataset_settings.options.address_required',
                    phone_required: 'fields.dataset_settings.options.phone_required',
                    email_required: 'fields.dataset_settings.options.email_required',
                    website_required: 'fields.dataset_settings.options.website_required',
                    vat_required: 'fields.dataset_settings.options.vat_required',
                    webshop_required: 'fields.dataset_settings.options.webshop_required',
                    exclude_branches: 'fields.dataset_settings.options.exclude_branches',
                    exclude_holdings: 'fields.dataset_settings.options.exclude_holdings',
                    exclude_bankruptcies: 'fields.dataset_settings.options.exclude_bankruptcies'
                }
            };
        },
        computed: {
            toggleValues() {
                return Object.keys(this.modelValue).filter(key => this.modelValue[key]);
            },
            optionsArray() {
                return Object.entries(this.options).map(([value, text]) => ({
                    value,
                    text
                }));
            },
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            },
            count() {
                const mutations = Object.keys(this.options).reduce((count, key) => {
                    if (this.modelValue[key] !== this.defaultVal[key]) {
                        count++;
                    }
                    return count;
                }, 0);
                
                return {
                    total: Object.keys(this.options).length,
                    mutations: mutations,
                    selected: this.toggleValues.length,
                    not_selected: Object.keys(this.options).length - this.toggleValues.length
                }
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation();
                }
                this.$emit('update:modelValue', { ...this.defaultVal });
            },
            onChanged(selectedValues) {
                const updatedModel = {};
                
                Object.keys(this.options).forEach(key => {
                    updatedModel[key] = false;
                });
                
                selectedValues.forEach(value => {
                    updatedModel[value] = true;
                });
                
                this.$emit('update:modelValue', updatedModel);
            }
        }
    }
</script>